import { Box } from "@mui/material";
import { type ReactNode } from "react";

export default function Container({ children }: { children: ReactNode }) {
  return <Box sx={{ px: 2 }}>{children}</Box>;
}
